export default __webpack_public_path__ + "static/media/heartLike.e7d3ae8d.svg";